<script>
import { formatPrettyDateTime } from '@utils/data/date-time'

export default {
  props: {
    deviceCondition: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    prettyDate() {
      return formatPrettyDateTime(this.deviceCondition.condition.start)
    },
  },
}
</script>

<template>
  <div>
    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info pt-2 mb-0 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 mb-0  text-uppercase pt-1 ">
          <span class="clearfix">
            {{ deviceCondition.firstDeviceEvent.device.name }}
            <span class="text-danger">{{ deviceCondition.condition.name }}</span>
          </span>
        </b-col>
      </b-row>
    </b-card-body>
    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info p-0 pt-2 pb-2 mb-3 clearfix"
    >
      <span
        class=" font-weight-bold text-uppercase btn-block text-muted float-right  pl-3"
      >
        Time
      </span>
      <div class="font-weight-bold text-uppercase pb-0 pl-3 pr-3 pt-1 mb-0">
        <p class="mb-1"> {{ prettyDate }}</p>
      </div>
      <span
        class=" font-weight-bold text-uppercase btn-block text-muted float-right  pl-3"
      >
        total Occured
      </span>
      <div class="font-weight-bold text-uppercase pb-0 pl-3 pr-3 pt-1 mb-0">
        <p class="mb-1">
          {{ deviceCondition.condition.count }}<span class="text-muted"> </span
        ></p>
      </div>
    </b-card-body>
  </div>
</template>

<style lang="scss">
.device-info {
  min-width: 145px;
  max-height: 65px;
  overflow: hidden;
}
.device-info-row {
  overflow: hidden;
}
.device-card-body-info {
  overflow: hidden;
  border-radius: 0 !important;
}
</style>
